module.exports = __webpack_public_path__ + "static/media/elements_section2_slide5.dd9ff7cc.png";